import React, { memo } from 'react';

// styles
import './style.scss';
import ButtonCardIcon from 'components/ButtonCardIcon';
import { useHistory } from 'react-router-dom';

function QuickLinks({ user }) {
  const history = useHistory();

  return (
    <div className="quickly-link">
      <ButtonCardIcon
        title="Absences"
        icon="absence"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/absences`,
          });
        }}
      />
      <ButtonCardIcon
        title="Classes"
        icon="users"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/classes`,
          });
        }}
      />
      <ButtonCardIcon
        title="Cours"
        icon="book"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/сours`,
          });
        }}
      />
      <ButtonCardIcon
        title="Etudiants"
        icon="academic"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/etudiants`,
          });
        }}
      />
      <ButtonCardIcon
        title="Utilisateurs"
        icon="person"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/utilisateurs`,
          });
        }}
      />
      <ButtonCardIcon
        title="Rapports"
        icon="document"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/rapports`,
          });
        }}
      />
      <ButtonCardIcon
        title="Paramètres"
        icon="parameters"
        className="link-button"
        action={() => {
          history.push({
            pathname: `/settings`,
          });
        }}
      />
      <ButtonCardIcon
        title="École"
        icon="school"
        className="school-button"
        action={() => {
          history.push({
            pathname: `/`,
          });
        }}
      />
    </div>
  );
}

QuickLinks.defaultProps = {};
QuickLinks.propTypes = {};

export default memo(QuickLinks);
